import * as React from "react";

type Props = {
    label: string;
};

type State = {
    label: string;
};

class Subtitle extends React.Component<Props, State> {
    state: State = { label: "Title" };

    render() {
        return <h2>{this.props.label}</h2>;
    }
}

export default Subtitle;
